import {SET_DECLINE_REASON} from "../actions/DeclineReasonActions";

export const declineReason = (state="", action)=>{
    switch(action.type){
        case SET_DECLINE_REASON:
            return action.declineReason;
        default:
            return state
    }
};